exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n\r\n\r\n\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/tracenow-mobile-app/tracenow-mobile-app.component.css
// module id = ../../../../../src/app/tracenow-mobile-app/tracenow-mobile-app.component.css
// module chunks = main